import React, { useState } from 'react';
import { ChevronDown, Building } from 'lucide-react';
export const DepartmentSelector = ({
  activeDepartment,
  setActiveDepartment
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const departments = ['General Manager Office', 'Finance Department', 'HR Department', 'IT Department', 'Legal Department', 'Audit Department'];
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleSelectDepartment = department => {
    setActiveDepartment(department);
    setIsOpen(false);
  };
  return <div className="relative" data-id="element-211">
      <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50" onClick={toggleDropdown} data-id="element-212">
        <Building className="h-4 w-4 text-gray-500" data-id="element-213" />
        <span data-id="element-214">{activeDepartment}</span>
        <ChevronDown className="h-4 w-4 text-gray-500" data-id="element-215" />
      </button>
      {isOpen && <div className="absolute z-10 mt-1 w-72 bg-white rounded-md shadow-lg border border-gray-200" data-id="element-216">
          <div className="py-1" data-id="element-217">
            {departments.map(department => <button key={department} className={`block w-full text-left px-4 py-2 text-sm ${department === activeDepartment ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'}`} onClick={() => handleSelectDepartment(department)} data-id="element-218">
                {department}
              </button>)}
          </div>
        </div>}
    </div>;
};